import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { Company } from '../../classess/company/company';
import { Customer } from '../../classess/customer/customer';
import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj, getResponse, setSeparatorsNumbers, settings,
    handleResponseMessageAsync, LoadingSection, setDateTimeFormatGlobalString
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { SaleService } from '../../services/purchases/SaleService';
import { StatementAccount } from '../../classess/sales/statementAccount';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, messages, } = settings;

const currentMethod = 'SaleDetailStatementAccounts';

export default function SaleDetailStatementAccounts({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const { id, customerId, } = useParams();
    const auth = useAuth();
    const isMount = useRef(true);
    const dtSalesId = 'dtDevices';
    const [process, setProcess] = useState({
        showLoading: false,
    });
    const [showData, setShowData] = useState(true);
    const [company, setCompany] = useState(Company?.getClass({}, false));
    const [customer, setCustomer] = useState(Customer?.getClass({}, false));
    const [balanceTotals, setBalanceTotals] = useState({ documents: 0.00, others: 0.00, });
    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
        },
        icons: {
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
    };
    //#endregion variables

    //#region methods
    //#region statement account
    const getStatementAccountDetails = async ({
        e = {},
        docType = '',
        docNumber = '',
        description = '',
        rowId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getStatementAccountDetails';
        let response = getResponse({ type: 0 });
        try {
            window.location.href = `${backend?.urls?.sales}${backend?.urls?.saleDetailDocuments}/${id}/${customerId}/${docType}/${docNumber}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    //#endregion statement account

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let companiesData = [];
            let customersData = [];
            let statementAccountData = [];
            let balanceTotalsData = { documents: 0.00, others: 0.00, };
            //#endregion variables

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true }));
                setShowData(true);

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (statement account)
                response = await SaleService.getBillToPayCompanyCustomerAsync({
                    token: auth?.user?.token?.token,
                    companyId: parseInt(id),
                    customerId: parseInt(customerId),
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                companiesData = response?.result?.companies || [];
                setCompany(prev => (companiesData[0] || {}));
                customersData = response?.result?.customers || [];
                setCustomer(prev => (customersData[0] || {}));
                statementAccountData = response?.result?.statementAccount || [];
                balanceTotalsData = response?.result?.balanceTotals || balanceTotalsData;
                setBalanceTotals(prev => balanceTotalsData);
                //#endregion get data (statement account)

                //#region set datatable
                if (!isUndNullEmp({ data: statementAccountData, subMethod: currentMethod, })?.result &&
                    statementAccountData.length > 0) {
                    response = setDataInDataTable({
                        statementAccountData: statementAccountData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            $(`#${dtSalesId}`).DataTable({
                columns: [
                    { title: labels?.type?.[languageObj?.id], width: '7%', },
                    { title: labels?.number?.[languageObj?.id], className: 'text-right', width: '7%', },
                    { title: labels?.emision?.[languageObj?.id], width: '10%', },
                    { title: labels?.expiration?.[languageObj?.id], width: '10%', },
                    { title: labels?.daysToExpireAbr2[languageObj?.id], className: 'text-right', width: '8%', },
                    { title: labels?.expiredDaysAbr2[languageObj?.id], className: 'text-right', width: '8%', },
                    { title: labels?.netAmountDocumentAbr[languageObj?.id], className: 'text-right', width: '10%', },
                    { title: labels?.balanceDocumentAbr[languageObj?.id], className: 'text-right', width: '10%', },
                    { title: labels?.netAmountOtherAbr[languageObj?.id], className: 'text-right', width: '10%', },
                    { title: labels?.balanceOtherAbr[languageObj?.id], className: 'text-right', width: '10%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            $(`#${dtSalesId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtSalesId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'details':
                            getStatementAccountDetails({ e: e, docNumber: id_, docType: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        statementAccountData = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            const statementAccountDt = [];
            //#endregion variables

            //#region process
            statementAccountData.forEach((value) => {
                const saModel = StatementAccount?.getClass(value, false);

                const processButtons = [];
                statementAccountDt.push([
                    saModel.tipo_Doc,
                    saModel.nro_Doc,
                    setDateTimeFormatGlobalString({
                        date: saModel.fec_emis,
                        dateFormat: languageObj?.format?.date?.f1,
                        timeFormat: 0,
                        withSeconds: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    setDateTimeFormatGlobalString({
                        date: saModel.fec_Venc,
                        dateFormat: languageObj?.format?.date?.f1,
                        timeFormat: 0,
                        withSeconds: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    `<span class='text-success'><b>${saModel.nDiaPorVencer}</b></span>`,
                    `<span class='text-danger'><b>${saModel.nDiaVencido}</b></span>`,
                    setSeparatorsNumbers({ number: saModel.monto_Net_Doc, withDecimals: true })?.result,
                    setSeparatorsNumbers({ number: saModel.saldo_Doc, withDecimals: true })?.result,
                    setSeparatorsNumbers({ number: saModel.monto_Net_Nde1, withDecimals: true })?.result,
                    setSeparatorsNumbers({ number: saModel.saldo_Nde1, withDecimals: true })?.result,
                    getProcessButtons({
                        id: saModel.nro_Doc,
                        description: saModel.tipo_Doc,
                        showDetails: true,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: (saModel.saldo_Doc !== 0.00 || saModel.saldo_Nde1 !== 0.00),
                        showDelete: false,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: false,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtSalesId}`)?.DataTable()?.rows?.add(statementAccountDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.purchases?.billToPay} process={app?.views?.purchases?.billToPay} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) - Premium Bar v6.6 */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.detailStatementAccounts?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0 justify-content-center justify-content-sm-end'>
                                    <li className='breadcrumb-item'><a href='/' className='text-muted'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={backend?.urls?.sales} className='text-muted'>{labels?.billToPay?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={`${backend?.urls?.sales}${backend?.urls?.saleUserCompanyCustomers}/${id}`} className='text-muted'>{labels?.detailCompanyCustomers?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary font-weight-bold'>{labels?.detailStatementAccounts?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection
                                                alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                showText={true}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center flex-wrap justify-content-between'>
                                                    <div className='d-flex align-items-center mb-2 mb-md-0'>
                                                        <div className='d-flex flex-column mr-4'>
                                                            <div className='d-flex align-items-center mb-2'>
                                                                <div className='bg-light p-2 rounded-circle mr-2 shadow-lg' style={{ width: '35px', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <img alt={labels?.company?.[languageObj?.id]} style={{ height: '18px' }} src={images?.icons?.company}></img>
                                                                </div>
                                                                <h6 className='mb-0 font-weight-bold text-dark text-uppercase small' style={{ letterSpacing: '0.8px', fontWeight: '800' }}>{company?.name || ''}</h6>
                                                            </div>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bg-light p-2 rounded-circle mr-2 shadow-lg' style={{ width: '35px', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <img alt={labels?.customers?.[languageObj?.id]} style={{ height: '18px' }} src={images?.icons?.customers}></img>
                                                                </div>
                                                                <h5 className='mb-0 font-weight-bold text-primary'>{customer?.name || ''}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='ml-auto'>
                                                        <a className={`${controls?.buttons?.back?.defaultClass}`}
                                                            href={`${backend?.urls?.sales}${backend?.urls?.saleUserCompanyCustomers}/${id}`}>
                                                            <i className={controls?.icons?.back?.defaultClass}> </i> {labels?.back?.[languageObj?.id]}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-0 mt-3'>
                                                <TableIndex tableId={dtSalesId} languageObj={languageObj} />
                                            </div>

                                            <div className='card-footer bg-white border-top-0 pb-4 px-4 pt-0 mt-3'>
                                                <div className='row text-center align-items-center'>
                                                    <div className='col-md-6 d-none d-md-flex justify-content-start align-items-center'>
                                                        <div className='text-right mr-3'>
                                                            <small className='text-muted d-block'>{messages?.processCompletedSuccessfully?.[languageObj?.id]}</small>
                                                            <span className='badge badge-success px-3 shadow-sm'>{labels?.detailStatementAccounts?.[languageObj?.id]}</span>
                                                        </div>
                                                        <i className='fas fa-file-invoice text-muted fa-2x opacity-25'></i>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderRadius: '10px', borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.balanceDocuments?.[languageObj?.id]}</small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {setSeparatorsNumbers({ number: balanceTotals.documents, withDecimals: true, })?.result}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderRadius: '10px', borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.balanceOthers?.[languageObj?.id]}</small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {setSeparatorsNumbers({ number: balanceTotals.others, withDecimals: true, })?.result}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>
            </div>
        </div>
    )
}